import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';

import { /*object_type,*/ api_crud_base, api_crud_route, data_interface, endpoints } from './Config';

import { getTokenInfo } from './../../../UseToken';

import Loader from '../../Loader/Loader';

import Swal from 'sweetalert2'

import parse from 'html-react-parser';

import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'

import {

	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,
	reqFILE,
	handle_compressed_image_upload,
	passwordHash,
	pattern_email,
	pattern_vat
	//set_darkmode,

} from '../../../Utils';

import Hosts from '../../../Hosts';

import { language } from './Language';

export default function Regist(props) {
	const [, set_dados] = useState(null);
	const dados = useRef(null);

	const [lang, set_lang] = useState('pt');

	const [isloading, setLoading] = useState(true);
	const [is_uploading, set_is_uploading] = useState( { profile_picture: ' d-none', /*id: ' d-none', certificate: ' d-none', iban: ' d-none', emprego: ' d-none', emprego_horario: ' d-none', desempregado: ' d-none'*/ })
	const [isRedirect, setRedirect] = useState(false);
	const [refresh, setRefresh] = useState(0)

	const [show_delete_button, set_show_delete_button] = useState(false);

	const [is_password, set_is_password] = useState(false)
	const [new_password, set_new_password] = useState('')
	const [confirm_password, set_confirm_password] = useState('')

	//const [disabled, set_disabled] = useState(true)
	const [/*is_input_disabled*/, set_is_input_disabled] = useState(true);

	const [is_edit, set_is_edit] = useState(false)

	const delete_permission = ('trainer_user' !== getTokenInfo().profile);

	//const [files_upload, set_files_upload] = useState([]);
	const [files_image, set_files_image] = useState([]);
	//const [files_upload_name, set_files_upload_name] = useState([]);
	const [image_base64, set_image_base64] = useState([]);

	const aQualificacaoNivel = [
        { value: '0', level: "0", label: "Não sabe ler nem escrever"},
        { value: '1', level: "0", label: "< 4.º ano" },
        { value: '2', level: "0", label: "1.º ciclo (4.º ano)" },
        { value: '3', level: "1", label: "2.º ciclo (6.º ano)" },
        { value: '4', level: "2", label: "3.º ciclo (9.º ano)" },
        { value: '5', level: "3", label: "Ensino Secundário" },
        { value: '6', level: "4", label: "Ensino Secundário Dupla Certificação" },
        { value: '7', level: "5", label: "Ensino Pós-Secundário não superior" },
        { value: '8', level: "5", label: "Cursos superiores de curta duração" },
        { value: '9', level: "6", label: "Bacharelato/Licenciatura" },
        { value: '10', level: "6", label: "Pós-Graduação" },
        { value: '11', level: "6", label: "Bacharelato" },
        { value: '12', level: "6", label: "Licenciatura" },
        { value: '13', level: "6", label: "Licenciatura pré-Bolonha" },
        { value: '14', level: "7", label: "Mestrado Integrado" },
        { value: '15', level: "7", label: "Mestrado Pré-Bolonha" },
        { value: '16', level: "7", label: "Mestrado" },
        { value: '17', level: "8", label: "Doutoramento" }
    ];

	const fetch_id_info = async (id_serch) => {

		return await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id_serch}`)
			.then(res => {
				set_dados(dados.current = res.data[0]);

			})
			.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
	}

	const clean_data = () => {
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
		set_dados(dados.current.info.office = getTokenInfo().office)
		//console.log(dados.current)
	}

	useEffect(() => {
		clean_data();

		set_lang(localStorage.getItem('lang'))

		try {
			let test = props.location.state.operation;

			if (test === 'edit') {
				set_is_input_disabled(false)
				//set_disabled(true)

				set_is_edit(true)

				set_show_delete_button(true)

				fetch_id_info(props.location.state.item['id']).then(() => {
					setLoading(false)
				})
				return
			}

		} catch {
			clean_data()

			setLoading(false);

			setRedirect(false);
			return
		}

		return () => {
			clean_data()
		}

	}, [props])

	const handleSubmit = async e => {
		e.preventDefault();

		if (is_edit === true) {

			let terms_conditions_link = language[lang].edit_text_2 + '<a href="' + Hosts.WEB_SITE_URI + 'terms-conditions" target="_blank" rel="noreferrer">' + language[lang].terms_conditions_link + '</a></br>' + language[lang].edit_text;
			//console.log(terms_conditions_link)

			Swal.fire({
				title: language[lang].edit_title,
				html: ('trainer_user' !== getTokenInfo().profile) ? language[lang].edit_text : terms_conditions_link,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].edit_confirm,
				cancelButtonText: language[lang].edit_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {

					files_image.forEach(async (el_upload) => {
						if (el_upload !== null) {
							await uploadFiles(el_upload.files, el_upload.type, 'image')
						}
					})

					set_files_image([])
					set_image_base64([])

					if(is_password) {
						let password = new_password;
						dados.current.info.password = passwordHash(password);
					}

					reqPUT(api_crud_route, dados.current)
						.then(() => {
							set_new_password('')
							set_confirm_password('')
							
							//props.history.push(endpoints.list) 
						})
						.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
				}
			})

		} else {

			Swal.fire({
				title: language[lang].insert_title,
				text: language[lang].insert_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].insert_confirm,
				cancelButtonText: language[lang].insert_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {
					if(is_password) {
						let password = new_password;
						dados.current.info.password = passwordHash(password);
					}

					reqPOST(api_crud_route, dados.current)
						.then(() => { 
							set_new_password('')
							set_confirm_password('')
							
							props.history.push(endpoints.list) 
						})
						.catch(() => Swal.fire(language[lang].insert_error, '', 'info'))
				}
			})

		}
	}

	const handleSubmitPassword = async e => {
		e.preventDefault();

		Swal.fire({
			title: language[lang].edit_title,
			text: language[lang].edit_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].edit_confirm,
			cancelButtonText: language[lang].edit_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {
				reqPUT(api_crud_route, dados.current)
					.then(() => { 
						//props.history.push(endpoints.list) 
					})
					.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
			}
		})
	}

	function apagar() {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {
				reqDELETE(api_crud_route + '/', { id: dados.current.id })
					.then(res => {
						props.history.push(endpoints.list);
					})
					.catch(() => Swal.fire(language[lang].delete_error, '', 'info'))
			}
		})
	};

	const check_entity_field = async (field, value, entity) => {
		let search_string = ''

		if (entity === '') {
			search_string = `${api_crud_base}/entities/list/${getTokenInfo().companycode}/*`
		}
		else
			search_string = `${api_crud_base}/entities/list/${getTokenInfo().companycode}/${entity}`

		reqGET(search_string)
			.then(res => {
				//console.log(res.data)

				let ja_existe = false
				let user_id = ''

				if(props.location.state !== undefined && is_edit) {
					user_id = props.location.state.item['id']
				}

				res.data.forEach((k) => {
					if (k[field] === value && value !== '' && k['id'] !== user_id) {

						ja_existe = true
					}
				})

				if (ja_existe === false) {
					set_is_input_disabled(true)

					if (field === 'username') {
						set_is_input_disabled(false)
					}
					return

				} else {
					//set_disabled(true)

					set_dados(dados.current.info[field] = '');

					Swal.fire({
						title: language[lang].warning_title,
						text: (field === 'email' ? language[lang].warning_text_2 : language[lang].warning_text_1),
						icon: 'warning',
						showCancelButton: false,
						confirmButtonColor: '#0095e8',
						cancelButtonColor: '#d9214e',
						confirmButtonText: language[lang].warning_confirm,
						cancelButtonText: language[lang].warning_cancel
					})
					.then((result) => {
						if (result.isConfirmed) {
							set_is_input_disabled(true)
							//set_disabled(false)
						}
					})

				}
			})
	}

	const checkEmailValidation = (data, name) => {

		const pattern_email_validation = /^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$/;
	
		if(pattern_email_validation.test(data) === false){
			set_dados(dados.current.info[name] = '');
			//setRefresh(refresh + 1)

			Swal.fire({
				title: (name === 'email' ? language[lang].contact_email : language[lang].username_email),
				text: language[lang].email_error_message,
				icon: 'warning',
				showCancelButton: false,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].warning_confirm,
				cancelButtonText: language[lang].warning_cancel
			})
	
			/*confirmAlert({
			  title: language[lang].username_email,
			  message: language[lang].email_error_message,
			  buttons: [
				{
				  label: language[lang].back,
				  onClick: () => { return }
				}
	
			  ]
			});*/
		}
	  }

	const handle_change_info = (e) => {
		const { name, value } = e.target;

		set_dados(dados.current.info[name] = value)

		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current info:' + JSON.stringify(dados))
	}

	const handle_change_info_2 = (e) => {
		const { name, value } = e.target;

		set_dados(dados.current.info[name] = value)

		if ((name === 'email') && value !== '') {
			
			checkEmailValidation(value, 'email')
			check_entity_field('email', value, '')
			
		}

		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current info:' + JSON.stringify(dados))
	}

	const handle_change_addresses = (e, index = 0) => {
		const { name, value } = e.target;

		/* DEBUG*/
	
		//console.log('NAME:' + name)
		//console.log('Value:' + value)
		
		set_dados(dados.current.addresses[index][name] = value)

		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current adresses:' + JSON.stringify(dados))

	}

	const handle_change_info_qualifications = e => {
        const { value, dataset } = e.target;
        const { level, name } = dataset;

		if(dados.current.info['qualifications'] === undefined) {
			dados.current.info.qualifications = {
				id: '',
				level: '',
				name: '',
			}
		}

        set_dados( dados.current.info.qualifications.id = value );
        set_dados( dados.current.info.qualifications.level = level );
        set_dados( dados.current.info.qualifications.name = name );

  		console.log('Dados Current Qualifications:' + JSON.stringify(dados))
    }

	const handle_change_login = (e) => {
		const { value } = e.target;

		check_entity_field('username', value, '')

		if('Administrador' !== getTokenInfo().profile) {
      
			checkEmailValidation(value, 'username')
		}
	}

	const handle_change_info_new_password = (e) => {
		const { value } = e.target;

		set_new_password(value)
	}

	const handle_change_password = (e) => {
		const { value } = e.target;

		if(new_password === value) {
			set_is_password(true)
			//set_disabled(false)
		}
		else {
			Swal.fire(language[lang].password_text, '', 'info')
			set_is_password(false)
			//set_disabled(true)
		}
	}

	const convertBase64 = async (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
        
            fileReader.onload = () => {
                resolve(fileReader.result);
            };
        
            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    };

	const onChangeHandlerImage = (e) => {
		const { files, dataset } = e.target;
		const { type } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v) => {

			//console.log(v.type)
			if((v.type.includes('image/')) && (v.size < 10485760)){

				handle_compressed_image_upload(v, (valor) => storedFiles.push(valor))
				//storedFiles.push(v);

				const base64 = await convertBase64(v);
				
				let files_img_aux = image_base64
				
				files_img_aux = [{id: '1', name: v.name, type: type, link: base64}]
				set_image_base64(files_img_aux)

				if(dados.current.info['files'] === undefined) {
					dados.current.info['files'] = []
				}

				dados.current.info['files'] = dados.current.info['files'].filter(el_f => el_f.type !== type)

				//if(filesArray.length === (k + 1)) {
					set_dados(dados.current,)
					setRefresh(refresh + 1)
				//}
			}
			else {
				alert(language[lang].upload_file_error + v.name);
			}
		});

		let files_aux = files_image
		files_aux.push({ files: storedFiles, type: type })
		set_files_image(files_aux)

		//console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		//console.log('Dados Current files:' + JSON.stringify(dados))
	}

	const uploadFiles = (files, doc_type, type) => {
		let aux = []
		files.forEach((element) => {
			if (element.type === "application/pdf") {
				aux.push(element)

				uploadFile(element, doc_type, type)
					.then(() => {
						//console.log('success')
					})
			}
			if (element.type.includes('image/')) {
				aux.push(element)

				uploadFile(element, doc_type, type)
					.then(() => {
						//console.log('success')
					})
			}
			else {
				Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
			}
		})
	}

	const uploadFile = async (file, doc_type, type) => {
		const formData = new FormData()
		formData.append('files', file)
		formData.append('id', dados.current.id)
		formData.append('file_name', file.name)
		formData.append('type', 'user')
		formData.append('companycode', dados.current.info.companycode)
		formData.append('folder', Hosts.APP_REPO_FOLDER + 'upload/users/');

		//console.log('file.type', doc_type)

		let x_aux = is_uploading
		if(doc_type === 'profile-picture') {
			x_aux['profile_picture'] = ''
		}
		x_aux[doc_type] = ''
		set_is_uploading(x_aux)

		return await reqFILE(`${api_crud_base}/multimedia/file`, formData)
			.then((res) => {
				var today_file = new Date()

				let x = {
					id: '',
					info: {
						companycode: getTokenInfo().companycode,
						type: res.data.mimetype,
						link: res.data.path + '/' + res.data.name,
						size: res.data.size,
						date: today_file
					},
					content: {
						name: file.name,
						description: '',
						lang: []
					}
				}

				if (type === 'doc') {

					if(dados.current.info['files'] === undefined) {
						dados.current.info['files'] = []
					}

					let aux = dados.current.info['files'].filter(el_f => el_f.type !== doc_type)
					aux.push({
						id: '',
						link: res.data.path + '/' + res.data.name,
						name: file.name,
						description: '',
						type: doc_type
					})
					dados.current.info['files'] = aux
				}

				if (type === 'image') {

					if(dados.current.info['files'] === undefined) {
						dados.current.info['files'] = []
					}

					let aux = dados.current.info['files'].filter(el_f => el_f.type !== doc_type)
					aux.push({
						id: '',
						link: res.data.path + '/' + res.data.name,
						name: file.name,
						description: '',
						type: doc_type
					})
					dados.current.info['files'] = aux
				}

				reqPUT(api_crud_route, dados.current)
					.then(() => {
						//props.history.push(endpoints.list) 

						if(doc_type === 'profile-picture') {
							x_aux['profile_picture'] = ' d-none'
						}

						x_aux[doc_type] = ' d-none'
						set_is_uploading(x_aux)

						setRefresh(refresh + 1)
					})
					.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))

				reqPOST(`${api_crud_base}/multimedia`, x)
					.then(() => {

					})
					.catch(() => Swal.fire('Problema ao inserir Registo!', '', 'info'))

				return true

			})
			.catch(erro => console.log('Erro POST File: ' + erro))
	}

	const removeUserDocument = (type, index) => {
		//console.log('index do file: ', index)

		let del_value = dados.current.info.files.slice(index, index + 1);

		let document_file = dados.current.info.files.filter(v => v.type !== del_value[0].type);

		set_dados(dados.current.info.files = document_file)

		setRefresh(refresh + 1)

		console.log(dados.current.info.files)
	}

	return isloading ?
		
		<Loader />

		:
		isRedirect
			?
			<Redirect to={endpoints.list} replace />
			:

			<main>
				<div className={`dash-cards header`}>
					<h2 className="dash-title">{language[lang].entity}</h2>
					<span>
						{
							('trainer_user' !== getTokenInfo().profile) ?

								<Link to={{ pathname: endpoints.list }}  >
									{language[lang].entity}
								</Link>

							:
								language[lang].entity
						}
						&nbsp;&#47;&nbsp;
						{ dados.current.id !== '' ? language[lang].entity_edit : language[lang].entity_new }
					</span>
				</div>
		
				<div className={`dash-cards body`}>
                	<div className="container">
		
						<div className="row">
							<div className="mb-5">
								<div className="card">
									<div className="card-header border-0" aria-expanded="true" aria-controls="div_entidade_info">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].personal_data}</h3>
										</div>
									</div>
									<div id="div_entidade_info" className="collapse show">
										<form id="form" onSubmit={handleSubmit}>

											<div className="card-body border-top p-4">
												<div className="row">
													<div className="col-12 mb-3">
														<label className="fw-bold">
															{parse(language[lang].terms_conditions_required)}
														</label>
													</div>
													<div className="col-12 mb-3">
														<div className='row'>
															<div className="col-12 col-sm-6 div-image">
																<label className="col-form-label fw-bold fs-6">{language[lang].image_profile}</label>
																<div className="dropzone-panel mb-2">
																	<div className="div-form-input custom-file">
																		<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"input-file-profile-picture"}>{language[lang].image_choose}</label>
																		<input 
																			id={"input-file-profile-picture"}
																			type="file" 
																			accept="image/*"
																			data-type={'profile-picture'}
																			className="dropzone-select btn btn-sm btn-primary me-2 d-none" 
																			onChange={onChangeHandlerImage}
																		/> 
																		<div className={"spinner-border position-absolute" + is_uploading['profile_picture']} role="status">
																			<span className="visually-hidden">Loading...</span>
																		</div>
																		{
																			dados.current.info['files'] !== undefined ?
																				dados.current.info.files.map((el_f, k_f) => {
																					if(el_f.type === 'profile-picture') {
																						return (
																							<div key={k_f} className='col-12 col-sm-4 position-relative mt-3'>
																								<img className='img-fluid' alt={el_f.name} title={el_f.name} src={el_f.link} />
																								<span 
																									className="btn btn-icon rounded-0 bg-white border shadow m-1 position-absolute"
																									onClick={() => removeUserDocument(el_f.type, k_f)}
																									alt={language[lang].image_remove}
																									title={language[lang].image_remove}
																									style={{right: 0}}
																								>
																									<i className="bi bi-x fs-3"></i>
																								</span>
																							</div>
																						)
																					}
																					else {
																						return null
																					}
																				})
																			:
																				null
																		}

																		{
																			image_base64.map((el_f, k_f) => {
																				if(el_f.type === 'profile-picture') {
																					return (
																						<p key={k_f} className=' mt-3'>
																							<img style={{marginTop: '10px', maxWidth: '100%', maxHeight:'217px'}} alt={el_f.name} title={el_f.name} src={el_f.link} />
																						</p>
																					)
																				}
																				else {
																					return null
																				}
																			})
																		}
																	</div>
																</div>
															</div>
														</div>
													</div>
													<div className="col-6 col-md-6 mb-3">
														<label className="col-form-label fs-6 fw-bold">{language[lang].name}&nbsp;({language[lang].profile})<span className='text-danger'>&#42;</span></label>
														<input type="text" name="name" value={dados.current.info.name} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].name_placeholder} onChange={handle_change_info} required />
													</div>

													<div className="col-6 col-md-6 mb-3">
														<label className="col-form-label fs-6 fw-bold">{language[lang].surname}&nbsp;({language[lang].profile})<span className='text-danger'>&#42;</span></label>
														<input type="text" name="surname" value={dados.current.info.surname} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].surname_placeholder} onChange={handle_change_info} required />
													</div>

													<div className="col-12 mb-3">
														<label className="col-form-label fs-6 fw-bold">{language[lang].name_full}<span className='text-danger'>&#42;</span></label>
														<input type="text" name="name_full" value={dados.current.info.name_full} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].name_full_placeholder} onChange={handle_change_info} required />
													</div>

													<div className="col-6 mb-3">
														<label className="col-form-label fs-6 fw-bold">{language[lang].contact_email}<span className='text-danger'>&#42;</span></label>
														<input type="email" pattern={pattern_email} name="email" value={dados.current.info.email} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].contact_email_placeholder} onChange={handle_change_info} onBlur={handle_change_info_2} required />
													</div>
													<div className="col-6 mb-3">
														<label className="col-form-label fs-6 fw-bold">{language[lang].phone_number}<span className='text-danger'>&#42;</span></label>
														<PhoneInput
															defaultCountry="PT"
															className="form-control mb-3 mb-lg-0 rounded-0"
															placeholder={language[lang].phone_number_placeholder}
															value={dados.current.info.phone !== '' ? dados.current.info.phone : null}
															onChange={e => set_dados(dados.current.info.phone = e)}
															required 
														/>
														{/*<input type="tel" name="phone" pattern="[0-9]{9}" value={dados.current.info.phone} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].location_placeholder} onChange={handle_change_info} />*/}
													</div>
													<div className="col-6 col-md-6 mb-3">
														<label className="col-form-label fs-6 fw-bold">{language[lang].address}</label>
														<input type="text" name="address" value={dados.current.addresses[0].address} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].address_placeholder} onChange={handle_change_addresses} />
													</div>
													<div className="col-6 col-md-3 mb-3">
														<label className="col-form-label fs-6 fw-bold">{language[lang].postal_code}</label>
														<input type="text" name="postal_code" pattern="[0-9]{4}-[0-9]{3}" value={dados.current.addresses[0].postal_code} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].postal_code_placeholder} onChange={handle_change_addresses} />
													</div>
													<div className="col-6 col-md-3 mb-3">
														<label className="col-form-label fs-6 fw-bold">{language[lang].location}</label>
														<input type="text" name="location" value={dados.current.addresses[0].location} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].location_placeholder} onChange={handle_change_addresses} />
													</div>
													<div className="col-6 mb-3">
														<label className="col-form-label fs-6 fw-bold">{language[lang].village}</label>
														<input type="text" name="village" value={dados.current.addresses[0].village} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].village_placeholder} onChange={handle_change_addresses} />
													</div>
													<div className="col-6 mb-3">
														<label className="col-form-label fs-6 fw-bold">{language[lang].municipality}</label>
														<input type="text" name="municipality" value={dados.current.addresses[0].municipality} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].municipality_placeholder} onChange={handle_change_addresses} />
													</div>
													<div className="col-6 col-md-4 mb-3">
														<label className="col-form-label fs-6 fw-bold">{language[lang].date_birth}</label>
														<input type="date" name="date_birth" value={dados.current.info.date_birth} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].date_birth_placeholder} onChange={handle_change_info} />
													</div>
													<div className="col-6 col-md-4 mb-3">
														<label className="col-form-label fs-6 fw-bold">{language[lang].age}</label>
														<input type="number" name="age" min={1} value={dados.current.info.age} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].age_placeholder} onChange={handle_change_info} />
													</div>
													<div className="col-6 col-md-4 mb-3">
														<label className="col-form-label fs-6 fw-bold">{language[lang].place_birth}</label>
														<input type="text" name="place_birth" value={dados.current.addresses[0].place_birth} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].place_birth_placeholder} onChange={handle_change_addresses} />
													</div>
													<div className="col-12 col-sm-6 col-md-3 mb-3">
														<label className="col-form-label fs-6 fw-bold">{language[lang].id_type}</label>
																						
														<select className="form-select rounded-0" aria-label="Select ID Type" name='id_type' value={dados.current.info.id_type} onChange={handle_change_info}>
															<option value="id_type_citizen_card">{language[lang].id_type_citizen_card}</option>
															<option value="id_type_identity_card">{language[lang].id_type_identity_card}</option>
															<option value="id_type_passport">{language[lang].id_type_passport}</option>
														</select>
														
													</div>
													<div className="col-12 col-sm-6 col-md-3 mb-3">
														<label className="col-form-label fs-6 fw-bold">{language[lang].id_number}</label>
														<input type="number" name="id_number" pattern="\d*" inputMode='numeric' maxLength="11" value={dados.current.info.id_number} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].id_number_placeholder} onChange={handle_change_info} />
													</div>
													<div className="col-12 col-sm-6 col-md-3 mb-3">
														<label className="col-form-label fs-6 fw-bold">{language[lang].id_validity}</label>
														<input type="date" name="id_validity" value={dados.current.info.id_validity} className="form-control mb-3 mb-lg-0 rounded-0" /*placeholder={language[lang].id_validity_placeholder}*/ onChange={handle_change_info} />
													</div>
													<div className="col-12 col-sm-6 col-md-3 mb-3">
														<label className="col-form-label fs-6 fw-bold">NIF</label>
														<input type="text" name="nif" pattern={pattern_vat} minLength="9" inputMode='numeric' value={dados.current.info.nif} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].nif_placeholder} onChange={handle_change_info} />
													</div>
													<div className="col-12 col-sm-6 mb-3">
														<label className="col-form-label fs-6 fw-bold">NIB/IBAN</label>
														<div className='input-group'>
															<span className="input-group-text" id="default-iban">PT50</span>
															<input type="text" name="nib_iban" inputMode='numeric' value={dados.current.info.nib_iban} className="form-control mb-3 mb-lg-0 rounded-0" aria-describedby="default-iban" placeholder={language[lang].nib_iban_placeholder} onChange={handle_change_info} />
														</div>
													</div>

													<div className="col-12 mb-3">
														<div className="row">
															<h3 className="fw-bolder mb-3">{language[lang].educational_background}</h3>
															<label className="col-form-label fw-bold fs-6 d-none">{language[lang].educational_background}</label>
															{
																aQualificacaoNivel.map( ( v , k ) => {
																	return (
																		<div className="col-6 col-sm-3 mb-2" key={k}>
																			<input
																				id={"qualifications_" + k}
																				type="radio"
																				//className='form-check-input'
																				name="qualifications"
																				value={v.value}
																				data-level={v.level}
																				data-name={v.label}
																				checked={dados.current.info.qualifications !== undefined && dados.current.info.qualifications.id === v.value ? true : false}
																				onChange={handle_change_info_qualifications}
																				//required={course_registration_operation ? true : false}
																			/>
																			<label className="assec-pl-5" htmlFor={"qualifications_" + k}>{v.label}</label>
																		</div>
																	)
																})
															}
														</div>
													</div>
													<div className="col-12 col-sm-4 mb-3">
														<label className="col-form-label fs-6 fw-bold">{language[lang].formation_area}</label>
														<input type="text" name="formation_area" value={dados.current.info.formation_area} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].formation_area_placeholder} onChange={handle_change_info} />
													</div>
													<div className="col-6 mb-3 d-none">
														<label className="col-form-label fs-6 fw-bold">{language[lang].professional_area}</label>
														<input type="text" name="professional_area" value={dados.current.info.professional_area} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].professional_area_placeholder} onChange={handle_change_info} />
													</div>
												</div>

												<div className="card-footer d-flex justify-content-end py-3 px-5 d-none">
													<Link className="btn btn-light btn-active-light-primary me-2" to={{ pathname: endpoints.list }}  >
														<span>{language[lang].cancel}</span>
													</Link>

													<button onClick={() => apagar(dados.current.id)} className={show_delete_button ? "btn btn-danger me-2" : "d-none"}>
														<span>{language[lang].delete}</span>
													</button>

													<button type="submit" form="form" className="btn btn-primary">
														<span>{language[lang].save}</span>
													</button>
												</div>
											</div>
										</form>
									</div>
								</div>

								<div className="card mt-5">
									<div className="card-header border-0" aria-expanded="true" aria-controls="div_entidade_password">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].login_data}</h3>
										</div>
									</div>
									<div id="div_entidade_password" className="collapse show">
										<form id="form_1" onSubmit={handleSubmitPassword}>

											<div className="card-body border-top p-4">

												<div className="row mb-6">
													<div className="col-md-4 fv-row">
														<label className="col-form-label fs-6 fw-bold">{language[lang].username_email}</label>
														<input type="text" name="username" value={dados.current.info.username} /*pattern={'Administrador' !== getTokenInfo().profile ? pattern_email : ''}*/ className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].username_placeholder} onChange={handle_change_info} onBlur={handle_change_login} required />
													</div>
													<div className="col-md-4 fv-row">
														<label className="col-form-label fs-6 fw-bold">{language[lang].password}</label>
														<input type="password" name="password" value={new_password} min="9" title="A password deve de conter pelo menos 9 digitos alfa-númericos" className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].password_placeholder} onChange={handle_change_info_new_password} autoComplete="off" />
													</div>
													<div className="col-md-4 fv-row">
														<label className="col-form-label fs-6 fw-bold">{language[lang].password_confirmation}</label>
														<input type="password" name="password_conf" defaultValue={confirm_password} min="9" className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].password_placeholder} onBlur={handle_change_password} autoComplete="off" />
													</div>
												</div>

												<div className="card-footer d-flex justify-content-end py-6 px-9 d-none">
													<Link className="btn btn-light btn-active-light-primary me-2" to={{ pathname: endpoints.list }}  >
														<span>{language[lang].cancel}</span>
													</Link>

													<button onClick={() => apagar(dados.current.id)} className={show_delete_button ? "btn btn-danger me-2" : "d-none"}>
														<span>{language[lang].delete}</span>
													</button>

													<button type="submit" form="form" className="btn btn-primary">
														<span>{language[lang].save}</span>
													</button>
												</div>
											</div>
										</form>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								{ delete_permission ? (
									<li className="nav-item">
										<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
											{/*<img alt='' src={'./img/cancelar.svg'} />
											<span>{language[lang].cancel}</span>*/}
											<img alt={language[lang].back} src={'./img/seta_2.svg'} />
											<span>{language[lang].back}</span>
										</Link>
									</li>
								) : null }
								{ delete_permission ? (
									<li className={"nav-item " + show_delete_button}>
										<button type="button" onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
											<img alt={language[lang].delete} src={'./img/eliminar_b.svg'} />
											<span>{language[lang].delete}</span>
										</button>
									</li>
								) : null }
								<li className="nav-item">
									<button type="submit" form="form" className="nav-link">
										<img alt={language[lang].save} src={'./img/save.svg'} />
										<span>{language[lang].save}</span>
									</button>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</main>
}
